import { Heading } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Icon } from "@mittwald/flow-remote-react-components";
import { IllustratedMessage } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { IconFolderCancel } from "@tabler/icons-react";
import { ModalTrigger } from "@mittwald/flow-remote-react-components";
import { CreateDirectoryProtectionModal } from "./CreateDirectoryProtectionModal";

export const NoDirectoryProtections = (props: { projectId: string }) => {
  return (
    <IllustratedMessage>
      <Icon>
        <IconFolderCancel />
      </Icon>
      <Heading>Kein Passwortschutz angelegt</Heading>
      <Text>
        Lege deinen ersten Passwortschutz an, um deine Apps vor unberechtigtem
        Zugriff zu schützen.
      </Text>
      <ModalTrigger>
        <Button color="success">Passwortschutz anlegen</Button>
        <CreateDirectoryProtectionModal projectId={props.projectId} />
      </ModalTrigger>
    </IllustratedMessage>
  );
};
